'use client';

import { useRef } from 'react';

import type {
    CalendarEvent,
} from '@/components/event-calendar';

import { EventItem } from '@/components/event-calendar';

type DraggableEventProps = {
    'event': CalendarEvent;
    'view': 'month' | 'week' | 'day';
    'showTime'?: boolean;
    'onClick'?: (e: React.MouseEvent) => void;
    'height'?: number;
    'isMultiDay'?: boolean;
    'multiDayWidth'?: number;
    'isFirstDay'?: boolean;
    'isLastDay'?: boolean;
    'aria-hidden'?: boolean | 'true' | 'false';
    'className'?: string;
    'hideContent'?: boolean;
    'isSelected'?: boolean;
    'children'?: React.ReactNode;
};

export function DraggableEvent({
    event,
    view,
    showTime,
    onClick,
    height: _height,
    isMultiDay: _isMultiDay,
    multiDayWidth: _multiDayWidth,
    isFirstDay = true,
    isLastDay = true,
    'aria-hidden': ariaHidden,
    className,
    hideContent,
    isSelected,
    children,
}: DraggableEventProps) {
    const elementRef = useRef<HTMLDivElement>(null);

    // Check if this is a multi-day event
    // no-op: draggable removed

    return (
        <div
            ref={(node) => {
                if (elementRef)
                    elementRef.current = node;
            }}
            className="touch-none"
        >
            <EventItem
                event={event}
                view={view}
                showTime={showTime}
                isFirstDay={isFirstDay}
                isLastDay={isLastDay}
                isDragging={false}
                onClick={onClick}
                className={className}
                hideContent={hideContent}
                isSelected={isSelected}
                aria-hidden={ariaHidden}
            >
                {children}
            </EventItem>
        </div>
    );
}
